const landing_page = {
  aboutUs: "Tentang kami", // translated 
  topPackages: "Paket Teratas", // translated 
  featuredHotels: "Hotel Unggulan", // translated 
  topTours: "Tur Teratas", // translated 
  whatOurMembersSay: "Apa yang anggota kami katakan...", // translated 
  followUsOnInstagram: "Ikuti kami di Instagram", // translated 
  pleaseWait: "Harap tunggu...", // translated 
  packages: "Paket", // translated 
  ourPartners: "Mitra Kami", // translated 
  trustedCarHirePartners: "Mitra Penyewaan Mobil Tepercaya", // translated 
  learnMore: "Belajarlah lagi", // translated 
};



export default landing_page;
